import { CustomAppsCombinedProps } from './types';

const usePresenter = (props: CustomAppsCombinedProps): CustomAppsCombinedProps => {
  return props;
};

export default usePresenter;
